/// <amd-module name="Wit/UI/Components/WorkItemState/WorkItemState.Props" />

import { IObservableValue } from "VSS/Core/Observable";

/**
 * Type of work item state and color.
 */
export type WorkItemStateAndColor = {
    /**
     * State name.
     */
    name: string;
    /**
     * Fill color in hex format of 'RRGGBB'.
     */
    fill?: string;
    /**
     * Category of state
     */
    category?: string;
};

/**
 * Property for the WorkItemState component
 */
export interface IWorkItemStateProps {
    /**
     * The state and color data to render the component
     */
    data: WorkItemStateAndColor | IObservableValue<WorkItemStateAndColor>;
    /**
     * Optional custom class name for the component.
     */
    className?: string;
    /**
     * Optional property to hide state value text.
     * @default false
     */
    hideText?: boolean;
}
